import CustomSelect, { OpcaoDoCustomSelect } from 'components/custom-select';

/** O que o seletor precisa de um ciclo (`task_cycle__c`). */
export interface CicloDoSeletor {
  _id: string;
  title: string;
  status?: string;
}

/** PAD-10: "2S2026 · ciclo atual" para o ciclo aberto (`status === 'open'`), "1S2026 · encerrado" para os demais. */
export function rotuloDoCiclo(ciclo: CicloDoSeletor) {
  return `${ciclo.title} · ${ciclo.status === 'open' ? 'ciclo atual' : 'encerrado'}`;
}

export function opcoesDeCiclo(ciclos: CicloDoSeletor[]): OpcaoDoCustomSelect[] {
  return ciclos.map(ciclo => ({ value: ciclo._id, label: rotuloDoCiclo(ciclo) }));
}

interface SeletorDeCicloProps {
  ciclos: CicloDoSeletor[];
  /** `_id` do ciclo escolhido. */
  valor: string | undefined;
  onChange: (cicloId: string) => void;
  /**
   * Nome acessível (PAD-11). Com um rótulo visível na tela, o mesmo texto dele (o `CustomSelect` sempre põe
   * `aria-label`, que vence o `<label>`). Padrão: "Selecione o ciclo".
   */
  rotulo?: string;
  /** `id` do campo, para o `<label htmlFor>` visível da tela levar o clique ao seletor. */
  inputId?: string;
  /** Desabilitado enquanto a tela não pode trocar de ciclo (a fila do gestor carregando). */
  desabilitado?: boolean;
  className?: string;
}

/**
 * Seletor de ciclo único das telas da nova identidade (PAD-10): o `CustomSelect` claro, com o menu desenhado
 * pelo app (igual em todo navegador) e os ciclos rotulados pelo status. O seletor do menu lateral não usa este:
 * fica sobre o azul, com a variante `sidebar`.
 */
export default function SeletorDeCiclo({
  ciclos,
  valor,
  onChange,
  rotulo = 'Selecione o ciclo',
  inputId,
  desabilitado,
  className,
}: SeletorDeCicloProps) {
  const opcoes = opcoesDeCiclo(ciclos);

  return (
    <CustomSelect
      variant="light"
      options={opcoes}
      value={opcoes.find(opcao => opcao.value === valor) ?? null}
      onChange={opcao => opcao && onChange(String(opcao.value))}
      ariaLabel={rotulo}
      inputId={inputId}
      disabled={desabilitado}
      placeholder="Selecione o ciclo"
      className={className}
    />
  );
}
